import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ContentPage } from '../models/content-page';
import { DirectusImageData } from '../models/directus-image-data';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  imageBaseUrl = environment.directusBaseUrl + 'assets/';
  imageDataBaseUrl = environment.directusBaseUrl + 'items/image_data/';

  constructor(private http: HttpClient) {}

  getUrlById = (imageId: string) => this.imageBaseUrl + imageId;

  getImageDataByImageId = (imageId: string) =>
    this.http
      .get(this.imageDataBaseUrl + '?filter[image][_eq]=' + imageId + '&fields=*.*')
      .toPromise()
      .then((response: { data: DirectusImageData[] }) => {
        if (response.data && response.data.length > 0) {
          return response.data[0];
        }
      });
}
